import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Button, Modal, TextField } from "@mui/material";
import "toastr/build/toastr.min.css";
import { styleForPourAndDispenseModal } from "./pour_and_dispense_utils";
import PourAndDispenseModalCloseIcon from "./pour_and_dispense_close_icon";

const PourAndDispenseNotesModal = ({ isOpen, onComplete, currentValue }) => {
  const [noteText, setNoteText] = useState();

  useEffect(() => {
    setNoteText(currentValue);
  }, [currentValue]);

  const onClose = () => {
    onComplete(noteText);
  };

  return (
    <Modal open={isOpen} onClose={onClose} aria-labelledby="client-note-dialog-title">
      <Box className="ccw-dialog pour_and_dispense_dialog" sx={styleForPourAndDispenseModal}>
        <PourAndDispenseModalCloseIcon onClick={() => onComplete()} />
        <div className="pour_and_dispense_dialog__header">
          <div>
            <p className="ccw-operations-eyebrow">Client context</p>
            <h2 id="client-note-dialog-title">Client note</h2>
          </div>
        </div>
        <div className="pour_and_dispense_modal_container_shared_style pour_and_dispense_dialog__body">
          <TextField
            fullWidth
            label="Note"
            multiline
            onChange={(event) => setNoteText(event.target.value)}
            value={noteText || ""}
            rows={3}
          />
        </div>
        <div className="pour_and_dispense_dialog__actions">
          <Button className="ccw-button" onClick={() => onComplete()}>
            Cancel
          </Button>
          <Button className="ccw-button ccw-button--primary" onClick={onClose}>
            Save note
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

PourAndDispenseNotesModal.propTypes = {
  isOpen: PropTypes.bool,
  onComplete: PropTypes.func,
  currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default PourAndDispenseNotesModal;
